import React, { useState, useEffect } from "react";
import "./style.scss";
import { login } from "../helper";
import Select from "components/BaseWidgets/select";
import Input from "components/BaseWidgets/form/input";
import Button from "components/BaseWidgets/button";
import RadioButton from "components/BaseWidgets/radioButton";
import AlertNotification from "components/CustomWidgets/alertNotification";
import OtpModal from "../OtpModal";
import SuccessModal from "components/Account/components/successModal/index ";
import { useNavigate } from "react-router-dom";
import { useSelectOptions, useSelectCode } from "hooks/api/useListing";
import { usePreRegister } from "hooks/api/useAuth";
import Divider from "components/BaseWidgets/divider";
import Loader from "components/BaseWidgets/Loader";

function UserOnboarding() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    profileFor: null,
    name: "",
    contact: "",
    Countrycodes: null,
  });
  const [fieldSelection, setFieldSelection] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const { mutate: register, isPending } = usePreRegister({
    onSuccess: () => {
      setIsModalOpen(true);
    },
  });

  const { profileCreatedFor } = useSelectOptions();

  const { data: countrylist, isLoading: isCommunityPending } = useSelectCode({
    search_key: "",
  });
  const CountryCodes = countrylist?.country_codes?.map((item) => {
    return {
      value: item.id,
      label: item.code,
      phone_length: item.phone_length,
    };
  });

  useEffect(() => {
    if (CountryCodes && !formData.Countrycodes) {
      const defaultCode = CountryCodes.find((c) => c.label === "+91");
      if (defaultCode) {
        setFormData((prev) => ({ ...prev, Countrycodes: defaultCode }));
      }
    }
  }, [CountryCodes, formData.Countrycodes]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = () => {
    const missingFields = [];

    if (!formData.profileFor) missingFields.push("profile for");
    if (!formData.name) missingFields.push("name");
    if (!formData.contact) missingFields.push("contact information");

    if (missingFields.length > 0) {
      const message = `Please enter ${missingFields.join(", ")}.`;
      AlertNotification("error", message);
      return;
    }

    const formFields = {
      identifier: formData.contact,
      name: formData.name,
      profile_for: formData.profileFor,
    };
    if (formData?.Countrycodes && fieldSelection) {
      formFields.countrycode = formData.Countrycodes.value;
    }
    register(formFields);
  };

  const handleOtpSuccess = () => {
    setIsModalOpen(false);
    setOpenModal(true);
  };

  const handleSuccess = () => {
    setOpenModal(false);
    navigate("/create", { state: { userData: formData } });
  };

  return (
    <section className={"form-wrapper"}>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader spinning />
        </div>
      ) : (
        <div className={"form-container"}>
          <div className={"input-group"}>
            <Select
              value={formData.profileFor}
              label="Profile for"
              className={"user-onboarding-select"}
              options={profileCreatedFor?.options}
              placeholder="Select profile"
              inputClassName={"user-onboarding-select"}
              onChange={(value) => handleInputChange("profileFor", value)}
              allowClear={true}
              isLoading={profileCreatedFor?.isLoading}
              SkeletonHeight={30}
            />
          </div>

          <Divider
            type="vertical"
            height="50px"
            width={1}
            color="#E6E8EC"
            className={"input-divider"}
          />

          <div className={"input-group"}>
            <Input
              value={formData.name}
              inputClassname={"user-onboarding-input"}
              onChange={(e) => handleInputChange("name", e.target.value)}
              placeholder={"Enter name"}
              label="Name of Bride/Groom"
              id="name"
            />
          </div>

          <Divider
            type="vertical"
            height="50px"
            width={1}
            color="#E6E8EC"
            className={"input-divider"}
          />
          <div className="radio-button-wrapper w-full flex flex-col">
            <div className="radio-button-container flex flex-col">
              <div className="selection-area">
                <label className="input-label">Register with</label>
                <div className="option-select">
                  <RadioButton
                    value={fieldSelection}
                    className="radio-button-label"
                    radioGroupClass="radio-group"
                    options={login}
                    variant="secondary"
                    onChange={(e) => {
                      setFieldSelection(e.target.value);
                    }}
                  />
                </div>
              </div>
              <>
                {fieldSelection ? (
                  <div className={"input-group mt-1"}>
                    <div className="phone-input-area">
                      <Select
                        // showSearch={false}
                        value={formData.Countrycodes}
                        className={"user-onboarding-select"}
                        options={CountryCodes}
                        inputClassName={"user-onboarding-select"}
                        onChange={(value) => {
                          const selectedOption = CountryCodes.find(
                            (item) => item.value === value,
                          );
                          handleInputChange("Countrycodes", selectedOption);
                          handleInputChange("contact", "");
                        }}
                        allowClear={true}
                        SkeletonHeight={30}
                      />
                      <Input
                        value={formData.contact}
                        placeholder={"Enter number"}
                        inputClassname={"user-onboarding-input"}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          handleInputChange("contact", value);
                        }}
                        id="phone-number"
                        maxLength={formData?.Countrycodes?.phone_length}
                      />
                    </div>
                  </div>
                ) : (
                  <div className={"input-group mt-1"}>
                    <Input
                      value={formData.contact}
                      placeholder={"Enter email ID"}
                      inputClassname={"user-onboarding-input"}
                      onChange={(e) =>
                        handleInputChange("contact", e.target.value)
                      }
                      id="phone-number"
                    />
                  </div>
                )}
              </>
            </div>
          </div>
          <Button
            isLoading={isPending}
            className={`register-btn`}
            onClick={handleSubmit}
          >
            Register for Free
          </Button>
        </div>
      )}

      <OtpModal
        fieldSelection={fieldSelection}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        title="OTP Verification"
        formData={formData}
        onSuccess={handleOtpSuccess}
      />

      <SuccessModal
        open={openModal}
        onCancel={handleSuccess}
        onOk={handleSuccess}
        title="Verification successful!"
        description="Your verification is successful! Your profile is now more secure and trusted."
      />
    </section>
  );
}

export default UserOnboarding;
